<template>
  <main-layout>
    <base-breadcrumb :routes="breadcrumb" />
    <base-card
      class="px-3 black"
    >
      <base-heading
        :level="2"
        class="ml-n2 mt-n3 pt-3"
      >
        {{ pageTitle() }}
      </base-heading>
      <div>
        <top-links
          v-if="event === 'click'"
          :loading="loading"
          :links="items"
          :page-size="pageSize"
          :count="count"
          @bottom-reached="onBottomReached"
          @view-details="onViewClickDetails"
        />
      </div>
    </base-card>
    <client-click-events-modal-container
      v-if="showClicksModal"
      :url="modalData.url"
      :count="modalData.count"
      :outreach-id="outreachId"
      @closed="onModalClosed"
    />
    <client-email-events-container
      v-if="showEventsModal"
      :show="showEventsModal"
      :outreach-id="outreachId"
      :customer="modalData.customer"
      :edit="modalData.edit"
      @closed="onModalClosed"
    />
  </main-layout>
</template>
<script type="text/javascript">
import Listable from '@/components/mixins/listable';
import ClientClickEventsModalContainer from '@/components/Widgets/ClientHistory/ClientClickEventsModalContainer';
// import TopClients from './TopClients'
import TopLinks from './TopLinks';

export default {
  name: 'TopStatsContainer',
  components: {
    // TopClients,
    TopLinks,
    ClientClickEventsModalContainer,
  },
  mixins: [Listable],
  props: {
    source: {
      type: String,
      default: 'events',
    },
    pageSize: {
      type: Number,
      default: 30,
    },
  },
  data() {
    return {
      showEventsModal: false,
      showClicksModal: false,
      modalData: {},
    };
  },
  computed: {
    breadcrumb() {
      return [{
        name: 'Reports',
        link: '/reports',
      },
      {
        name: this.$store.state.outreachs.stats.edit
          ? this.$store.state.outreachs.stats.edit.subject : 'Outreach Stats',
        link: `/reports/outreach/${this.outreachId}/stats/`,
      },
      {
        name: this.pageTitle(),
      },
      ];
    },
    event() {
      return this.$route.params.event;
    },
    outreachId() {
      return this.$route.params.id;
    },
    count() {
      return this.event === 'click'
        ? this.$store.state.events.clickedLinksCount
        : this.$store.state.events.clientOpensCount;
    },
    items() {
      return this.event === 'click'
        ? this.$store.state.events.clickedLinks
        : this.$store.state.events.clientOpens;
    },
    loading() {
      return this.$store.state.events.loading;
    },
    fetchPayload() {
      return {
        outreach: this.outreachId,
        page: this.currentPage,
        page_size: this.pageSize,
        // customer: customerEmail  // Soon to be used.
      };
    },
  },
  mounted() {
    // Retrieve events
    this.fetchData();
  },
  methods: {
    pageTitle() {
      if (this.event === 'click') {
        return 'All Links Clicked';
      }
      return 'All Clients Who Opened';
    },
    fetchData() {
      if (this.loading) {
        console.debug('already loading');
        return;
      }
      this.requestFailed = false;

      if (this.event === 'click') {
        this.fetchDetailedData('addClickedLinks');
      } else {
        this.fetchDetailedData('addClientOpens');
      }
    },
    fetchDetailedData(items) {
      this.$store.dispatch(`${this.source}/${items}`, this.fetchPayload).then((response) => {
        if (response && response.data) {
          this.nextPageExists = response.data.next != null;
        }
      }).catch((response) => {
        if (response.response == null) {
          // Network error
          this.requestFailed = true;
        } else if (response.response.status === 404) {
          // Page doesn't exist
        } else {
          // Server errro
          this.requestFailed = true;
        }
        this.$store.commit(`${this.source}/setIsLoading`, false);
      }).finally(() => {});
    },
    onViewEventDetails(customer) {
      this.modalData = { customer, edit: this.$store.state.outreachs.stats.edit };
      this.showEventsModal = true;
    },
    onViewClickDetails({ url, count }) {
      this.modalData = { url, count };
      this.showClicksModal = true;
    },
    onModalClosed() {
      this.modalData = {};
      this.showClicksModal = false;
      this.showEventsModal = false;
    },
    onCustomerClicked(customerPk) {
      this.$router.push(`/clients/${customerPk}`);
    },
    onBottomReached() {
      if (this.nextPageExists) {
        this.truePage += 1;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.black {
  color: $black;
}
</style>
